import type { SchoolLunchBoxOrderDeliveryTime } from "@luna-restaurant/school-api";

export const getLunchBoxDeliveryTimeTranslationKey = (
  deliveryTime: SchoolLunchBoxOrderDeliveryTime,
) => `lunchBoxes.deliveryTimes.${deliveryTime}` as const;
